import BarCodes from "./components";

const routes = {
  path: "barCode",
  children: [{ path: "", element: <BarCodes /> }],
};

export default routes;
